import { useEffect, useState } from "react";
import Reset from "../Images/reset.png";
import AudiosService from "../Services/Audios";
import AuthorsService from "../Services/Authors";
import WithoutLyrics from "../Images/audiolyrics.svg";
import WithLyrics from "../Images/audiowithoutlyrics.svg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import $ from "jquery";
import ListPagination from "../Components/ListPagination";
import "../Styles/Audios.css";
import "../Styles/Sidebar.css";
import { useTranslation } from "react-i18next";
import i18n, { _get_i18Lang } from "../i18n";
import imgdownload from "../Images/downloadpravachan.svg";
import imgpause from "../assets/audioPlayer/img/yellowplay.svg";
import { useUser } from "../Contexts/UserContext";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "@mui/material";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { LogInModel } from "./LoginModel";
import Loader from "./Loader";
import { FilterIcon, SortIcon } from "./Icon";

const PravachansPage = () => {
  const { isSelected, setItemColored } = useUser();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [audios, setAudios] = useState<any[] | undefined>(undefined);
  const [refresh, setRefresh] = useState(false);
  const [SortValue, setSortValue] = useState("");
  const [Type, setType] = useState<any | undefined>(undefined);
  const [SortMonthValue, setSortMonthValue] = useState<string>("0");
  const [SortYearValue, setSortYearValue] = useState<string>("0");
  const [year, setYear] = useState<any>([])
  const [time, setTime] = useState<any>([])
  const [sortTime, SetSortTime] = useState<string>("")
  const [hoveredPreacher, setHoveredPreacher] = useState<any>(null);
  const [hoveredCategory, setHoveredCategory] = useState<any>(null);

  const [Lyrics, setLyrics] = useState<any>("");
  const [LyricsId, setLyricsId] = useState<any>("");
  const [Category, setCategory] = useState<any>("");
  const [CategoryId, setCategoryId] = useState<any>("");
  const [Preacher, setPreacher] = useState<any>("");
  const [PreacherId, setPreacherId] = useState<any>("");
  const UserIdentity = localStorage.getItem("UserId") as any;
  const [special, setSpecial] = useState<boolean>(false)
  const [otherpreacher, setOtherpreacher] = useState<boolean>(false)

  const [pagination, setPagination] = useState({
    pageNo: 0,
    recordsPerPage: 12,
    totalRecords: 0,
  });

  var timestamp = new Date().getTime();
  const encoded = btoa(timestamp.toString());

  const location = useLocation();
  const state = location.state as { authorId: string; authorName: string, orderNo: number };

  const [logIn, setLogIn] = useState<boolean>(false);
  const [clickedAudio, setClickedAudio] = useState<{ audio: any, index: number } | null>(null);

  const [loading, setLoading] = useState(true);

  const closeModal = () => {
    setLogIn(false);
    setClickedAudio(null);
  };

  const [activeIndex, setActiveIndex] = useState(null);
  const [bread, showBread] = useState("");

  const handleItemClick = (index: any) => {
    setActiveIndex(index);
  };

  const [loginState, setLoginState] = useState<boolean>(false);

  const handleLoginStateChange = (newState: any) => {
    setLoginState(newState === true);
    localStorage.setItem("type", "pravachans");

    // Navigate only to the specific audio that was clicked
    if (newState === true && clickedAudio) {
      const { audio, index } = clickedAudio;
      navigate(`/pravachans/` + audio.slug, {
        state: {
          audioId: audio.id,
          audioslug: audio.slug,
          sorting: SortValue,
          pageNum: pagination.pageNo,
          index: index,
          audiocat: CategoryId,
          audioAuthor: state?.authorId || PreacherId,
          isOther: otherpreacher
        },
      });
      // Clear the clicked audio data after navigation
      setClickedAudio(null);
    }
  };

  function ResetData() {
    setPreacherId("");
    setCategoryId("");
    setLyricsId("");
    setSortValue("3");
    setSortMonthValue("0");
    setSortYearValue("0");
    setActiveIndex(null);
    setOtherpreacher(false);
    setSpecial(false);
    SetSortTime("");
    setPagination({
      ...pagination,
      pageNo: 0,
    });
    setRefresh(true);
  }

  function ClickOnFilter(par: string, cat: string, lyric: string, otherpreacher: boolean) {
    setRefresh(false);
    setType("pravachans");
    AudiosService.getAudios(
      0,
      pagination.recordsPerPage,
      false,
      CategoryId,
      PreacherId || state?.authorId,
      "",
      SortValue,
      "",
      special,
      Type,
      LyricsId,
      SortMonthValue,
      SortYearValue,
      "",
      sortTime,
      otherpreacher
    ).then((res) => {
      if (res?.status) {
        setAudios(res?.result?.items);
        setPagination({
          ...pagination,
          pageNo: 1,
          totalRecords: res?.result?.totalRecords,
        });
      }
    });
  }

  const downloadPravachan = (pravachanPath: any) => {
    const imageUrl = pravachanPath;
    const link = document.createElement('a');
    link.href = imageUrl; link.download = 'image.jpg';
    document.body.appendChild(link); link.click();
    document.body.removeChild(link);
  };

  useEffect(() => {
    AudiosService.getPravachanFilters("pravachan").then((res) => {
      if (res?.status) {
        const temporaryPreacher = [{ id: 1, name: t("Special_Pravachan_tr") }, ...res.result.authors, { id: 0, name: t("Other_pravachan_tr") }];
        const temporaryPreachers = [{ id: 1, name: t("Special_Pravachan_tr") }, ...res.result.authors];
        setCategory(res.result.categories);
        setLyrics(res.result);
        AudiosService.getAudios(0, 20, false, "", "", "", "", "", false, "pravachans", LyricsId, "", "", "", "", true).then((res) => {
          if (res.status) {
            setPreacher(res?.result?.totalRecords <= 0 ? temporaryPreachers : temporaryPreacher)
          }
        })
      }
    });
  }, [i18n.language]);

  // useEffect(() => {
  //   ClickOnFilter(PreacherId, CategoryId, LyricsId, otherpreacher);
  //   $(".CategoryList > ul > li > div").removeClass("listActive");
  //   $("#par-" + PreacherId).addClass("listActive");

  //   $(".Authorlist > ul > li > div").removeClass("listActive");
  //   $("#aut-" + CategoryId).addClass("listActive");

  //   $(".LanguageList > span").removeClass("listActive");
  //   $("#lan-" + 1).addClass("listActive");
  // }, [PreacherId, SortMonthValue, SortYearValue, CategoryId, LyricsId]);

  useEffect(() => {
    setItemColored(true);
    ResetData();
  }, [isSelected, setItemColored]);

  useEffect(() => {
    AuthorsService.GetAuthorDataById(state?.authorId).then((res) => {
      if (res?.status) {
        showBread(res?.result?.name);
      }
    });
  }, [i18n.language, refresh]);

  useEffect(() => {
    AudiosService.getYearReaponse().then((res: any) => {
      if (res?.status) {
        const temporaryYear = [{ id: 0, name: t("select_year_tr") }, ...res?.result];
        setYear(temporaryYear)
      }
    })
  }, [i18n.language, refresh]);

  useEffect(() => {
    AudiosService.getTimeReaponse().then((res: any) => {
      if (res?.status) {
        const temporaryTime = [{ id: 0, name: t("select_time_tr") }, ...res?.result];
        setTime(temporaryTime)
      }
    })
  }, [i18n.language, refresh]);

  useEffect(() => {
    if (state?.authorId) {
      if (state?.authorId === "5bbc5fa51fd2d735b0087d34" || state?.authorId === "5bbc5fcd1fd2d735b0087d35") {
        setSortValue("0")
        // setSortMonthValue("0");
        // setSortYearValue("0");
      }
      else if (state?.authorId === "5bbc60101fd2d735b0087d36") {
        setSortValue("4")
      }
    }
    else {
      if (PreacherId === "5bbc5fa51fd2d735b0087d34" || PreacherId === "5bbc5fcd1fd2d735b0087d35") {
        setSortValue("0")
        // setSortMonthValue("0");
        // setSortYearValue("0");
      }
      else if (PreacherId === "5bbc60101fd2d735b0087d36") {
        setSortValue("4")
      }
    }
  }, [state?.authorId, state?.authorName, PreacherId, i18n.language, refresh])

  useEffect(() => {
    setRefresh(false);
    setType("pravachans");
    const fetchData = async () => {
      try {
        const response = await AudiosService.getAudios(
          pagination.pageNo === 0
            ? 0
            : pagination.recordsPerPage * pagination.pageNo - 12,
          pagination.recordsPerPage,
          false,
          CategoryId,
          PreacherId ? PreacherId : state?.authorId ? state?.authorId : "",
          "",
          SortValue,
          "",
          special,
          Type,
          LyricsId,
          SortMonthValue,
          SortYearValue,
          "",
          sortTime,
          otherpreacher
        )
        const res = await response;
        setAudios(res.result?.items)
        setPagination({
          ...pagination,
          // recordsPerPage: 12,
          totalRecords: res?.result?.totalRecords,
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false); // Hide loader after fetching
      }
    }
    fetchData();
  }, [SortValue, i18n.language, refresh, CategoryId, PreacherId, sortTime, otherpreacher, SortMonthValue, SortYearValue]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);



  const authorTitle =
  state?.authorName === "श्रद्धेय श्रीजयदयालजी गोयन्दका"
    ? t("Jayadayal_Ji_pravachan_title")
    : state?.authorName === "श्रद्धेय श्रीहनुमानप्रसादजी पोद्दार"
    ? t("HanumanPrasad_Ji_pravachan_title")
    : state?.authorName === "श्रद्धेय स्वामी श्रीरामसुखदासजी महाराज"
    ? t("Ramsukhdas_Ji_pravachan_title")
    : t("Pravachan_title_tr");

const authorDescription =
  state?.authorName === "श्रद्धेय श्रीजयदयालजी गोयन्दका"
    ? t("Jayadayal_Ji_pravachan_description")
    : state?.authorName === "श्रद्धेय श्रीहनुमानप्रसादजी पोद्दार"
    ? t("HanumanPrasad_Ji_pravachan_description")
    : state?.authorName === "श्रद्धेय स्वामी श्रीरामसुखदासजी महाराज"
    ? t("Ramsukhdas_Ji_pravachan_description")
    : t("Pravachan_description_tr");



  return (
    <>
  <div style={{ backgroundColor: "rgb(255, 237, 188)", padding: "0px 0px 0px 0px",marginTop:"-60px" }}>
      <div style={{ width: "100%", maxWidth: "1200px", margin: "0 auto", padding: "0 10px",backgroundColor:"rgb(255, 237, 188)" }}>
            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "space-between",
                gap: "20px",
                flexWrap: "wrap",
                padding: "28px 0 16px",
              }}
            >
              <div style={{ flex: "0 1 260px", minWidth: "220px" }}>
                <div style={{ padding: "8px 0" }}>
                  <h2 style={{ color: "#cf2c24", fontSize: "40px", margin: 0, fontWeight: 700,marginTop:"70px", textShadow: "0px 0px 4px rgba(255,255,255,0.9)" }}>
                    {t("Pravachan_tr")}
                  </h2>
                  <div style={{ marginTop: "10px", fontSize: 19,fontWeight:600,color:"rgb(45, 42, 41)" }}>
                    <Link to="/" style={{ marginRight: "", color: "#2d2a29" }}>{t("Home_tr")}</Link>
                    <span style={{ margin: "0 6px" }}>/</span>
                    <span>{t("Pravachan_tr")}</span>
                  </div>
                </div>
              </div>

              <div
                style={{
                  width: "1px",
                  minHeight: "100px",
                  background: "#facc6f",
                  marginTop: "65px",
                }}
              />

              <div style={{ flex: "1 1 520px", minWidth: "300px" }}>
                <h1
                  style={{
                    textAlign: "center",
                    color: "rgb(228, 121, 7)",
                    textShadow: "0px 0px 4px rgba(255,255,255,0.9)",
                    fontWeight: 600,
                    margin: 0,
                    paddingTop:"30px",
                    // marginb:"-10px",
                    fontSize:"32px"
                  }}
                >
                  {/* {t("Pravachan_title_tr")} */}
                  {authorTitle}
                </h1>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginTop: "8px",
                    gap: "10px",
                    flexWrap: "wrap",
                  }}
                >
                  <div style={{ width: "250px", height: "1px", background: "#E5B15A" }} />
                  <svg
                    width="26"
                    height="18"
                    viewBox="0 0 26 18"
                    style={{ margin: "0 12px" }}
                  >
                    <rect x="1" y="7" width="2" height="4" rx="1" fill="#E5B15A" />
                    <rect x="5" y="4" width="2" height="10" rx="1" fill="#E5B15A" />
                    <rect x="9" y="1" width="2" height="16" rx="1" fill="#E5B15A" />
                    <rect x="13" y="4" width="2" height="10" rx="1" fill="#E5B15A" />
                    <rect x="17" y="1" width="2" height="16" rx="1" fill="#E5B15A" />
                    <rect x="21" y="4" width="2" height="10" rx="1" fill="#E5B15A" />
                  </svg>
                  <div style={{ width: "250px", height: "1px", background: "#E5B15A" }} />
                </div>

                <p
                  style={{
                    fontSize: 17,
                    color: "#4a4036",
                    textShadow: "0px 0px 4px rgba(255,255,255,0.8)",
                    // margin: "25px 0 -10px",
                    margin:"18px 0px 0px 0px",
                    width: "100%",
                    lineHeight: 1.75,
                    whiteSpace: "normal",
                    overflowWrap: "break-word",
                    textAlign: "justify",
                  }}
                >
                  {/* {t("Pravachan_description_tr")} */}
                  {authorDescription}
                </p>
              </div>
            </div>
      </div>
  </div>

      <div
        className="fontfamily"
        style={{
          userSelect: "none",
          backgroundColor: "rgb(255, 246, 225)",
          marginTop: "-3px",
          paddingTop: "1px",
        }}
      >
        <div className="containers">
          <div
            className="gst-page-content pagecontentbackground"
            style={{ backgroundColor: "#FFF6E1", paddingBottom: "3%" }}
          >
            <div className="row">
              <div className="col-lg-3">
                <div
                  style={{
                    display: "block",
                    padding: "16px",
                    borderRadius: "4px",
                    background: "#FFFAF0",
                    boxShadow: "0 0 7px 1px #f5deb1",
                    fontFamily: "ChanakyaUni",
                    height: "100%",
                  }}
                >
                  <div>
                    <div
                      className="cardbackground"
                      style={{ cursor: "pointer" }}
                    >
                      <FilterIcon/> <span className="boxheadtitle" style={{color:"rgb(228, 121, 7)"}}>{t("Filter_tr")}</span>
                      {(CategoryId !== "" || PreacherId !== "" || LyricsId !== "" || pagination.pageNo > 1) && (
                        <img
                          alt="reset"
                          src={Reset}
                          className="resetimg"
                          onClick={() => {
                            ResetData();
                          }}
                        />
                      )}
                    </div>

                    <div>
                      <div
                        className="filteryearmonth"
                        style={{
                          marginTop: "15px",
                          // display: "flex",
                          display: state?.authorId === "5bbc60101fd2d735b0087d36" ? "flex" : "none",
                          alignItems: "baseline",
                        }}
                      >
                        <div style={{ width: "30%" }}>
                          <span>{t("Year_tr")}</span>
                        </div>

                        <div style={{ width: "70%" }}>
                          <select
                            onChange={(e) => {
                              setSortYearValue(e.target.value);
                            }}
                            value={SortYearValue}
                          >
                            {year && year?.map((year: any) => {
                              return (
                                <option key={year.id} value={year?.name}>{year?.name}</option>
                              )
                            }
                            )}
                          </select>
                        </div>
                      </div>
                    </div>

                    <div
                      className="filteryearmonth"
                      style={{
                        paddingTop: "5px",
                        alignItems: "baseline",
                        // display: "flex",
                        display: state?.authorId === "5bbc60101fd2d735b0087d36" ? "flex" : "none",
                      }}
                    >
                      <div style={{ width: "30%" }}>
                        <span>{t("Month_tr")}</span>
                      </div>
                      <div style={{ width: "70%" }}>
                        <select
                          // disabled={SortYearValue !== "0" ? false : true}
                          onChange={(e) => {
                            setSortMonthValue(e.target.value);
                          }}
                          value={SortMonthValue}
                        >
                          <option value="0">{t("All_Months_tr")}</option>
                          <option value="1">{t("January_tr")}</option>
                          <option value="2">{t("February_tr")}</option>
                          <option value="3">{t("March_tr")}</option>
                          <option value="4">{t("April_tr")}</option>
                          <option value="5">{t("May_tr")}</option>
                          <option value="6">{t("June_tr")}</option>
                          <option value="7">{t("July_tr")}</option>
                          <option value="8">{t("August_tr")}</option>
                          <option value="9">{t("September_tr")}</option>
                          <option value="10">{t("October_tr")}</option>
                          <option value="11">{t("November_tr")}</option>
                          <option value="12">{t("December_tr")}</option>
                        </select>
                      </div>
                    </div>

                    <div
                      className="filteryearmonth"
                      style={{
                        paddingTop: "5px",
                        alignItems: "baseline",
                        // display: "flex",
                        display: state?.authorId === "5bbc60101fd2d735b0087d36" ? "flex" : "none",
                      }}
                    >
                      <div style={{ width: "30%" }}>
                        <span>{t("time_tr")}</span>
                      </div>
                      <div style={{ width: "70%" }}>
                        <select
                          onChange={(e) => {
                            SetSortTime(e?.target?.value);
                          }}
                          value={sortTime}
                        >
                          {time && time?.map((times: any) => {
                            return (
                              <option key={times?.id} value={times?.id}>{times?.name}</option>
                            )
                          }
                          )}
                        </select>
                      </div>
                    </div>

                    <div style={{ backgroundColor: "#fffaec" }}>
                      {/* Preacher */}
                      <Accordion
                        defaultExpanded
                        elevation={0}
                        style={{ display: state?.authorId ? "none" : "block" }}
                      >
                        <AccordionSummary
                          expandIcon={<ExpandMore />}
                          style={{
                            height: 0,
                            background: "#FFFAF0",
                            minHeight: "25px",
                            marginTop: "15px",
                          }}
                        >
                          {/* <h2 className="filtertitle">{t("Preacher_tr")}</h2> */}
                           <p className="filtertitle" style={{fontSize:"20px",paddingTop:10}}>{t("Preacher_tr")}</p>
                        </AccordionSummary>

                        <AccordionDetails
                          style={{
                            display: "block",
                            background: "#FFFAF0",
                            // padding: 0,
                          }}
                        >
                          {Preacher && Preacher.length > 0
                            ? Preacher?.map((preacher: any) => (
                          <div
                            key={`par-${preacher.id}`}
                            className="CategoryList"
                            onClick={() => {
                              setPreacherId(preacher?.id);
                              setOtherpreacher(preacher?.id == 0);
                              setSpecial(preacher?.id == 1);
                            }}
                            onMouseEnter={() => setHoveredPreacher(preacher.id)}
                            onMouseLeave={() => setHoveredPreacher(null)}
                          >
                            <ul style={{ margin: 0 }}>
                              <li>
                                <h2
                                  style={{
                                    fontSize: "21px",
                                    cursor: "pointer",
                                    fontWeight: PreacherId === preacher.id ? 600 : 400,
                                    color:
                                      PreacherId === preacher.id ||
                                      hoveredPreacher === preacher.id
                                        ? "#cf2c24"
                                        : "#545454",
                                    fontFamily: "ChanakyaUni",
                                    paddingTop: "10px",
                                    transition: "0.3s",
                                  }}
                                >
                                  {preacher.name}
                                </h2>
                              </li>
                            </ul>
                          </div>
                            ))
                            : ""}
                          <div style={{ display: PreacherId === "5bbc60101fd2d735b0087d36" ? "block" : "none", marginLeft: "20px" }}>
                            <div>

                              <div
                                className="filteryearmonth"
                                style={{
                                  marginTop: "15px",
                                  display: "flex",
                                  alignItems: "baseline",
                                }}
                              >
                                <div style={{ width: "30%" }}>
                                  <span>{t("Year_tr")}</span>
                                </div>

                                <div style={{ width: "80%" }}>
                                  <select
                                    onChange={(e) => {
                                      setSortYearValue(e.target.value);
                                    }}
                                    value={SortYearValue}
                                  >
                                    {year && year?.map((year: any) => (
                                      <option key={year?.id} value={year?.name}>{year?.name}</option>
                                    ))}
                                  </select>
                                </div>
                              </div>
                            </div>

                            <div
                              className="filteryearmonth"
                              style={{
                                paddingTop: "5px",
                                alignItems: "baseline",
                                display: "flex",
                              }}
                            >
                              <div style={{ width: "30%" }}>
                                <span>{t("Month_tr")}</span>
                              </div>
                              <div style={{ width: "80%" }}>
                                <select
                                  onChange={(e) => {
                                    setSortMonthValue(e.target.value);
                                  }}
                                  value={SortMonthValue}
                                >
                                  <option value="0">{t("All_Months_tr")}</option>
                                  <option value="1">{t("January_tr")}</option>
                                  <option value="2">{t("February_tr")}</option>
                                  <option value="3">{t("March_tr")}</option>
                                  <option value="4">{t("April_tr")}</option>
                                  <option value="5">{t("May_tr")}</option>
                                  <option value="6">{t("June_tr")}</option>
                                  <option value="7">{t("July_tr")}</option>
                                  <option value="8">{t("August_tr")}</option>
                                  <option value="9">{t("September_tr")}</option>
                                  <option value="10">{t("October_tr")}</option>
                                  <option value="11">{t("November_tr")}</option>
                                  <option value="12">{t("December_tr")}</option>
                                </select>
                              </div>
                            </div>

                            <div
                              className="filteryearmonth"
                              style={{
                                paddingTop: "5px",
                                alignItems: "baseline",
                                display: "flex",
                              }}
                            >
                              <div style={{ width: "30%" }}>
                                <span>{t("time_tr")}</span>
                              </div>
                              <div style={{ width: "80%" }}>
                                <select
                                  onChange={(e) => {
                                    SetSortTime(e?.target?.value);
                                  }}
                                  value={sortTime}
                                >
                                  {time && time?.map((times: any) => {
                                    return (
                                      <option key={times?.id} value={times?.id}>{times?.name}</option>
                                    )
                                  }
                                  )}
                                </select>
                              </div>
                            </div>

                          </div>
                        </AccordionDetails>
                      </Accordion>
                      {/* Pravachanlist  */}
                      <Accordion elevation={0} defaultExpanded={state?.authorId ? true : false}>
                        <AccordionSummary
                          expandIcon={<ExpandMore />}
                          style={{
                            height: 0,
                            background: "#FFFAF0",
                            minHeight: "39px",
                            margin: "0 0 -7px 0",
                          }}
                        >
                          {/* <h2 className="filtertitle">{t("Category_tr")}</h2> */}
                           <p className="filtertitle" style={{fontSize:"20px",paddingTop:10}}>{t("Category_tr")}</p>
                        </AccordionSummary>

                        
                        <AccordionDetails
                          style={{
                            display: "block",
                            background: "#FFFAF0",
                            // padding: 0,
                          }}
                        >
                          {Category && Category.length > 0
                            ? Category?.map((categorie: any) => (
                          <div
                              key={`c-${categorie.id}`}
                              className="Authorlist"
                              onClick={() => {
                                setCategoryId(categorie.id);
                              }}
                              onMouseEnter={() => setHoveredCategory(categorie.id)}
                              onMouseLeave={() => setHoveredCategory(null)}
                            >
                              <ul style={{ margin: "5px 0 0 0", paddingTop: 5 }}>
                                <li>
                                  <h2
                                    style={{
                                      fontSize: "21px",
                                      cursor: "pointer",
                                      fontWeight: CategoryId === categorie.id ? 600 : 400,
                                      color:
                                        CategoryId === categorie.id ||
                                        hoveredCategory === categorie.id
                                          ? "#cf2c24"
                                          : "#545454",
                                      fontFamily: "ChanakyaUni",
                                      transition: "0.3s",
                                    }}
                                  >
                                    {categorie.name}
                                  </h2>
                                </li>
                              </ul>
                            </div>
                            ))
                            : ""}
                        </AccordionDetails>
                      </Accordion>
                      {/* lyrics & without lyrics */}
                      <Accordion elevation={0}>
                        <AccordionSummary
                          expandIcon={<ExpandMore />}
                          style={{
                            height: 0,
                            background: "#FFFAF0",
                            minHeight: "39px",
                            margin: "0 0 -2px 0",
                          }}
                        >
                          {/* <h2 className="filtertitle">{t("Lyrics_tr")}</h2> */}
                           <p className="filtertitle" style={{fontSize:"20px",paddingTop:10}}>{t("Lyrics_tr")}</p>
                        </AccordionSummary>

                        <AccordionDetails
                          style={{
                            display: "block",
                            background: "#FFFAF0",
                            padding: 0,
                          }}
                        >
                          <div className="LyricsList">
                            <ul style={{ margin: 0 }}>
                              <li
                                key={1}
                                onClick={() => {
                                  handleItemClick(1);
                                  setLyricsId(1);
                                }}
                              >
                                <h2
                                  style={{
                                    color:
                                      activeIndex === 1 ? "#FF2E12" : "#545454",
                                    cursor: "pointer",
                                    fontSize: "21px",
                                    fontWeight: 400,
                                    fontFamily: "ChanakyaUni",
                                  }}
                                >
                                  {t("Lyrics_tr")}
                                </h2>
                              </li>
                              <li
                                key={2}
                                onClick={() => {
                                  handleItemClick(2);
                                  setLyricsId(2);
                                }}
                              >
                                <h2
                                  style={{
                                    color:
                                      activeIndex === 2 ? "#FF2E12" : "#545454",
                                    cursor: "pointer",
                                    fontSize: "21px",
                                    fontWeight: 400,
                                    fontFamily: "ChanakyaUni",
                                  }}
                                >
                                  {t("Without_Lyrics_tr")}
                                </h2>
                              </li>
                            </ul>
                          </div>
                        </AccordionDetails>
                      </Accordion>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-9">
                <div
                  className="detailbg"
                  style={{
                    display: "block",
                    padding: "16px",
                    borderRadius: "4px",
                    background: "rgb(255, 250, 240)",
                    boxShadow: "rgb(245, 222, 177) 0px 0px 7px 1px",
                    height: "100%",
                    fontFamily: "ChanakyaUni",
                  }}
                >
                  <div className="sidebarmargin">
                    <div className="align-items-center row" style={{marginTop:"-17px"}}>
                      <div className="col-6">
                        <div className="filter1" style={{ marginTop: "10px" }}>
                          <span className="total-records-text">

                          <span style={{ color:"rgb(228, 121, 7)", fontFamily: "ChanakyaUni", fontSize: "22px" }}>
                            {t("Total_Records_tr")}
                          </span> : {pagination.totalRecords}
                          </span>
                          
                        </div>
                      </div>
                      <div
                        className="filter1 col-6"
                        style={{ textAlign: "right" }}
                      >
                        <div className="filter1" style={{ textAlign: "right" }}>
                                                  <SortIcon/><span style={{color:"rgb(228, 121, 7)",fontFamily:"chanakyaUni",fontSize:"22px"}}>{t("Sort_tr")}</span>
                          <select
                            value={SortValue}
                            onChange={(e) => {
                              setSortValue(e.target.value);
                            }}
                            style={{
                              width: "178px",
                              backgroundColor: "rgb(255, 242, 213)",
                            }}
                          >
                            <option value="4">{t("ascending_date_tr")}</option>
                            <option value="5">{t("descending_date_tr")}</option>
                            <option value="0">{t("General_tr")}</option>
                            <option value="3">{t("Popular_tr")}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>

                  {audios && audios.length > 0 ? (
                    <div>
                      {audios?.map((audio, i) => (
                        <div key={`audio-${audio.id}`}>
                          <div className="sidebarmargin">
                            <div
                              className="pravchanBox"
                              style={{ display: "flex", padding: "15px 20px" }}
                            >
                              <div style={{ marginRight: "25px" }}>
                                <a>
                                  <img
                                    className="audioicon"
                                    src={
                                      audio.lyricsHash != null
                                        ? WithLyrics
                                        : WithoutLyrics
                                    }
                                    onError={(e) => {
                                      e.currentTarget.src = WithoutLyrics;
                                    }}
                                    alt={audio.name}
                                    title={audio.name}
                                    onClick={() => {
                                      // Play/open without login; download still requires UserIdentity
                                      localStorage.setItem("type", "pravachans")
                                      navigate(`/pravachans/` + audio.slug, {
                                        state: {
                                          audioId: audio.id,
                                          audioslug: audio.slug,
                                          sorting: SortValue,
                                          pageNum: pagination.pageNo,
                                          index: i,
                                          audiocat: CategoryId,
                                        },
                                      });
                                    }}
                                  />
                                </a>
                              </div>
                              <div style={{ width: "100%" }}>
                                <a
                                  style={{ cursor: "pointer", display: "grid" }}
                                  onClick={() => {
                                    // Play/open without login; download still requires UserIdentity
                                    localStorage.setItem("type", "pravachans")
                                    navigate(`/pravachans/` + audio.slug, {
                                      state: {
                                        audioId: audio.id,
                                        audioslug: audio.slug,
                                        sorting: SortValue,
                                        pageNum: pagination.pageNo,
                                        index: i,
                                        audiocat: CategoryId,
                                        audioAuthor: state?.authorId || PreacherId,
                                        isOther: otherpreacher
                                      },
                                    });
                                  }}
                                >
                                  <p
                                    style={{
                                      paddingTop: "3px",
                                      fontWeight: "600",
                                      fontSize: "20px",
                                      fontStyle: "normal",
                                      lineHeight: "25px",
                                      marginBottom: 0,
                                      overflow: "hidden",
                                    }}
                                  >
                                    <h3 style={{fontSize:"20px",fontWeight:600,color:""}}>
                                      {audio.name != null &&
                                        audio.name.length > 80
                                        ? audio.name.slice(0, 70) + "..."
                                        : audio.name}
                                    </h3>
                                    
                                  </p>
                                  {audio.author !== null || "" || undefined ?
                                    <label style={{ display: "flex" }}>
                                      <span style={{ fontSize: "20px" }}>{t("Preacher_tr")}</span>: {audio.author}
                                    </label>
                                    : ""}
                                  <label>{audio.description}</label>
                                  <label>{audio.pravachanLength}</label>
                                </a>
                              </div>

                              <div className="btns">
                                <div className="buttonres">
                                  <div id="download"
                                    title="Download"
                                  >
                                  </div>
                                  <a
                                    id="download"
                                    title="Download"
                                    onClick={() => {
                                      if (UserIdentity) {
                                        downloadPravachan(audio.pravachanPath != null
                                          ? audio.pravachanPath + "?t=" + encoded + "&download_attachment=true"
                                          : "no record found")
                                      } else {
                                        // Store the clicked audio data for after login
                                        setClickedAudio({ audio, index: i });
                                        setLogIn(true);
                                      }
                                    }}
                                  // href={
                                  //   `${process.env.REACT_APP_API_URL}/api/Pravachans/` +
                                  //   audio?.id +
                                  //   "/pravachan?t=" +
                                  //   "&download_attachment=true"
                                  // }
                                  >
                                    <img
                                      alt="download"
                                      src={imgdownload}
                                      className="downloadbtn"
                                    ></img>
                                  </a>
                                </div>
                                <div
                                  style={{
                                    cursor: "pointer",
                                    paddingLeft: "5px",
                                  }}
                                >
                                  <img
                                    alt=""
                                    onClick={() => {
                                      // Play/open without login; download still requires UserIdentity
                                      localStorage.setItem("type", "pravachans")
                                      navigate(`/pravachans/` + audio.slug, {
                                        state: {
                                          audioId: audio.id,
                                          audioslug: audio.slug,
                                          sorting: SortValue,
                                          pageNum: pagination.pageNo,
                                          index: i,
                                          audiocat: CategoryId,
                                          audioAuthor: state?.authorId || PreacherId
                                        },
                                      });
                                    }}
                                    title="Play"
                                    src={imgpause}
                                    className="playbtn"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                      <div className="col-12" style={{ marginTop: "30px", display: pagination.totalRecords <= 12 ? "none" : "block" }}>
                        <ListPagination
                          totalRecords={pagination.totalRecords}
                          recordsPerPage={pagination.recordsPerPage}
                          currentPage={pagination.pageNo}
                          onClick={(p) => {
                            setPagination({
                              ...pagination,
                              pageNo: p,
                            });
                            setRefresh(true);
                          }}
                        />
                      </div>
                    </div>
                  ) : (
                    <div className="ebooks-category resultnotfound">
                      {loading && <Loader loading={loading} />}
                      {t("result_not_found_tr")}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div >
      <LogInModel opens={logIn} onCloses={closeModal} onLoginStateChange={handleLoginStateChange} />
    </>
  );
};
export default PravachansPage;
